"use client"

import { MapPinX } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MapPinXIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MapPinXIcon = component(Icon)({ as: MapPinX })
